import { getDocument, GlobalWorkerOptions, type PDFDocumentProxy } from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";

let workerConfigured = false;

const ensureWorker = () => {
  if (!workerConfigured) {
    GlobalWorkerOptions.workerSrc = pdfWorker;
    workerConfigured = true;
  }
};

export const isPdfFile = (file: File): boolean =>
  file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");

export const pdfFileToText = async (file: File): Promise<string> => {
  ensureWorker();

  const arrayBuffer = await file.arrayBuffer();
  const pdf: PDFDocumentProxy = await getDocument({ data: arrayBuffer }).promise;

  const pageTexts: string[] = [];

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
    const page = await pdf.getPage(pageNumber);
    const content = await page.getTextContent();
    const pageText = content.items
      .map((item) => ("str" in item ? item.str : ""))
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();

    if (pageText) {
      pageTexts.push(`--- Page ${pageNumber} ---\n${pageText}`);
    }
  }

  return pageTexts.join("\n\n");
};
